/**
 * @generated SignedSource<<eea46cec802b7290efda10f4b88d0233>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountid"
      }
    ],
    "concreteType": "ProjectEntriesConnection",
    "kind": "LinkedField",
    "name": "getsubscriptionorderlistofprojects",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectEntry",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SOProjectListFetchQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SOProjectListFetchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "14b1fbfae4ada1194ae58f06f479cbeb",
    "id": null,
    "metadata": {},
    "name": "SOProjectListFetchQuery",
    "operationKind": "query",
    "text": "query SOProjectListFetchQuery(\n  $accountid: UUID!\n) {\n  getsubscriptionorderlistofprojects(accountid: $accountid) {\n    totalCount\n    nodes {\n      projectId\n      projectName\n    }\n  }\n}\n"
  }
};
})();

node.hash = "145e6c92ddaadb3a9eff9ad69358b88d";

module.exports = node;
